// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat_assistant_bot .expand_btn[data-v-6d4e1642] {
  width: 110px;
  height: 105px;
  background: #fff;
  transition: width 0.3s ease-in-out;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  border-radius: 15px;
  cursor: pointer;
  position: fixed;
  bottom: 20px;
  right: 20px;
  text-align: center;
  z-index: 9999;
}
.chat_assistant_bot .expand_btn.is_tablet_device[data-v-6d4e1642] {
  bottom: 70px !important;
}
.chat_assistant_bot .expand_btn .assistance_box[data-v-6d4e1642] {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.chat_assistant_bot .expand_btn .assistance_box img[data-v-6d4e1642] {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  height: 45px;
}
.chat_assistant_bot .expand_btn .assistance_box img[data-v-6d4e1642]:hover {
  transform: rotate(360deg);
  transition: transform 1s ease;
}
.chat_assistant_bot .expand_btn .assistance_box p[data-v-6d4e1642] {
  font-size: 12px;
  margin-bottom: 10px;
  letter-spacing: -0.5px;
  color: #000;
}
.chat_assistant_bot .expand_btn.position-left-alignment[data-v-6d4e1642] {
  left: 20px;
}
.chat_assistant_bot .assistant_header img[data-v-6d4e1642] {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  height: 45px;
}
.chat_assistant_bot .assistant_header img[data-v-6d4e1642]:hover {
  transform: rotate(360deg);
  transition: transform 1s ease;
}
.chat_assistant_bot .expand_btn.show[data-v-6d4e1642] {
  width: 500px;
}
.chat_assistant_bot .content[data-v-6d4e1642] {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 500px;
  background: #fff;
  text-align: center;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  cursor: pointer;
  z-index: 9999;
}
.chat_assistant_bot .content.position-left-alignment[data-v-6d4e1642] {
  left: 20px;
}
.chat_assistant_bot .content h6[data-v-6d4e1642] {
  margin: 0;
  white-space: nowrap;
  font-weight: bold;
  font-size: 1.3rem;
  letter-spacing: -1px;
  color: #000;
}
.chat_assistant_bot .content .chips__btn[data-v-6d4e1642] {
  background: rgba(255, 255, 255, 0.1);
  font-size: 13px;
  border-radius: 30px;
}
.chat_assistant_bot .content .chips__btn[data-v-6d4e1642]:hover {
  background: rgba(255, 255, 255, 0.15);
  transition: 0.5s;
  box-shadow: none !important;
}
.chat_assistant_bot .content .chips__btn[data-v-6d4e1642]:active {
  box-shadow: none;
  outline: none;
}
.chat_assistant_bot .br-15[data-v-6d4e1642] {
  border-radius: 15px;
}
.chat_assistant_bot .text-white-opacity[data-v-6d4e1642] {
  color: #ffffffcc;
}
.chat_assistant_bot .animate-fade[data-v-6d4e1642] {
  position: relative;
  animation: fadeIn-6d4e1642 0.8s;
}
.chat_assistant_bot .assistant_close_icon[data-v-6d4e1642] {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat_assistant_bot .assistant_close_icon em[data-v-6d4e1642] {
  transform: rotate(-360deg);
  transition: transform 1s ease;
  display: block;
  color: #0000005c;
  cursor: pointer;
  font-size: 12px !important;
}
.chat_assistant_bot .assistant_close_icon em[data-v-6d4e1642]:hover {
  transform: rotate(360deg);
  transition: transform 1s ease;
}
.chat_assistant_bot .animated_icon[data-v-6d4e1642] {
  animation: rotate-6d4e1642 550ms ease;
}
.chat_assistant_bot .py-c-3[data-v-6d4e1642] {
  padding: 1.2rem 0;
}
@keyframes fadeIn-6d4e1642 {
0% {
    right: -300px;
    opacity: 0;
}
100% {
    right: 0;
    opacity: 1;
}
}
@keyframes rotate-6d4e1642 {
0% {
    transform: rotate(-360deg);
    transition: transform 550ms ease;
}
100% {
    transform: rotate(360deg);
    transition: transform 550ms ease;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/ChatAssistant/ChatAssistant.vue","webpack://./ChatAssistant.vue"],"names":[],"mappings":"AACA;EAEI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gDAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;ACDJ;ADGI;EACE,uBAAA;ACDN;ADhBA;EAqBM,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;ACFN;ADvBA;EA4BQ,0BAAA;EACA,6BAAA;EACA,YAAA;ACFR;ADIQ;EACE,yBAAA;EACA,6BAAA;ACFV;ADhCA;EAuCQ,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;ACJR;ADQI;EACE,UAAA;ACNN;ADzCA;EAoDI,0BAAA;EACA,6BAAA;EACA,YAAA;ACRJ;ADUI;EACE,yBAAA;EACA,6BAAA;ACRN;ADlDA;EA+DI,YAAA;ACVJ;ADrDA;EAmEI,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;EACA,eAAA;EACA,aAAA;ACXJ;ADaI;EACE,UAAA;ACXN;ADpEA;EAmFM,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;ACZN;AD5EA;EA4FM,oCAAA;EACA,eAAA;EACA,mBAAA;ACbN;ADeM;EACE,qCAAA;EACA,gBAAA;EACA,2BAAA;ACbR;ADgBM;EACE,gBAAA;EACA,aAAA;ACdR;AD1FA;EA8GI,mBAAA;ACjBJ;AD7FA;EAkHI,gBAAA;AClBJ;ADhGA;EAsHI,kBAAA;EACA,+BAAA;ACnBJ;ADpGA;EA2HI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACpBJ;AD/GA;EAsIM,0BAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;ACpBN;ADsBM;EACE,yBAAA;EACA,6BAAA;ACpBR;AD3HA;EAqJI,qCAAA;ACvBJ;AD9HA;EAyJI,iBAAA;ACxBJ;AD2BE;AACE;IACE,aAAA;IACA,UAAA;ACzBJ;AD4BE;IACE,QAAA;IACA,UAAA;AC1BJ;AACF;AD6BE;AACE;IACE,0BAAA;IACA,gCAAA;AC3BJ;AD8BE;IACE,yBAAA;IACA,gCAAA;AC5BJ;AACF","sourcesContent":["\n.chat_assistant_bot {\n  .expand_btn {\n    width: 110px;\n    height: 105px;\n    background: #fff;\n    transition: width 0.3s ease-in-out;\n    overflow: hidden;\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n    border-radius: 15px;\n    cursor: pointer;\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    text-align: center;\n    z-index: 9999;\n\n    &.is_tablet_device {\n      bottom: 70px !important;\n    }\n\n    .assistance_box {\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        transform: rotate(-360deg);\n        transition: transform 1s ease;\n        height: 45px;\n\n        &:hover {\n          transform: rotate(360deg);\n          transition: transform 1s ease;\n        }\n      }\n\n      p {\n        font-size: 12px;\n        margin-bottom: 10px;\n        letter-spacing: -0.5px;\n        color: #000;\n      }\n    }\n\n    &.position-left-alignment {\n      left: 20px;\n    }\n  }\n\n  .assistant_header img {\n    transform: rotate(-360deg);\n    transition: transform 1s ease;\n    height: 45px;\n\n    &:hover {\n      transform: rotate(360deg);\n      transition: transform 1s ease;\n    }\n  }\n\n  .expand_btn.show {\n    width: 500px;\n  }\n\n  .content {\n    position: fixed;\n    right: 20px;\n    bottom: 20px;\n    width: 500px;\n    background: #fff;\n    text-align: center;\n    border-radius: 15px;\n    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n    cursor: pointer;\n    z-index: 9999;\n\n    &.position-left-alignment {\n      left: 20px;\n    }\n\n    h6 {\n      margin: 0;\n      white-space: nowrap;\n      font-weight: bold;\n      font-size: 1.3rem;\n      letter-spacing: -1px;\n      color: #000;\n    }\n\n    .chips__btn {\n      background: rgba(255, 255, 255, 0.1);\n      font-size: 13px;\n      border-radius: 30px;\n\n      &:hover {\n        background: rgba(255, 255, 255, 0.15);\n        transition: 0.5s;\n        box-shadow: none !important;\n      }\n\n      &:active {\n        box-shadow: none;\n        outline: none;\n      }\n    }\n  }\n\n  .br-15 {\n    border-radius: 15px;\n  }\n\n  .text-white-opacity {\n    color: #ffffffcc;\n  }\n\n  .animate-fade {\n    position: relative;\n    animation: fadeIn 0.8s;\n  }\n\n  .assistant_close_icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n    font-size: 12px;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    em {\n      transform: rotate(-360deg);\n      transition: transform 1s ease;\n      display: block;\n      color: #0000005c;\n      cursor: pointer;\n      font-size: 12px !important;\n\n      &:hover {\n        transform: rotate(360deg);\n        transition: transform 1s ease;\n      }\n    }\n  }\n\n  .animated_icon {\n    animation: rotate 550ms ease;\n  }\n\n  .py-c-3 {\n    padding: 1.2rem 0;\n  }\n\n  @keyframes fadeIn {\n    0% {\n      right: -300px;\n      opacity: 0;\n    }\n\n    100% {\n      right: 0;\n      opacity: 1;\n    }\n  }\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(-360deg);\n      transition: transform 550ms ease;\n    }\n\n    100% {\n      transform: rotate(360deg);\n      transition: transform 550ms ease;\n    }\n  }\n}\n",".chat_assistant_bot .expand_btn {\n  width: 110px;\n  height: 105px;\n  background: #fff;\n  transition: width 0.3s ease-in-out;\n  overflow: hidden;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n  border-radius: 15px;\n  cursor: pointer;\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  text-align: center;\n  z-index: 9999;\n}\n.chat_assistant_bot .expand_btn.is_tablet_device {\n  bottom: 70px !important;\n}\n.chat_assistant_bot .expand_btn .assistance_box {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.chat_assistant_bot .expand_btn .assistance_box img {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  height: 45px;\n}\n.chat_assistant_bot .expand_btn .assistance_box img:hover {\n  transform: rotate(360deg);\n  transition: transform 1s ease;\n}\n.chat_assistant_bot .expand_btn .assistance_box p {\n  font-size: 12px;\n  margin-bottom: 10px;\n  letter-spacing: -0.5px;\n  color: #000;\n}\n.chat_assistant_bot .expand_btn.position-left-alignment {\n  left: 20px;\n}\n.chat_assistant_bot .assistant_header img {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  height: 45px;\n}\n.chat_assistant_bot .assistant_header img:hover {\n  transform: rotate(360deg);\n  transition: transform 1s ease;\n}\n.chat_assistant_bot .expand_btn.show {\n  width: 500px;\n}\n.chat_assistant_bot .content {\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  width: 500px;\n  background: #fff;\n  text-align: center;\n  border-radius: 15px;\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;\n  cursor: pointer;\n  z-index: 9999;\n}\n.chat_assistant_bot .content.position-left-alignment {\n  left: 20px;\n}\n.chat_assistant_bot .content h6 {\n  margin: 0;\n  white-space: nowrap;\n  font-weight: bold;\n  font-size: 1.3rem;\n  letter-spacing: -1px;\n  color: #000;\n}\n.chat_assistant_bot .content .chips__btn {\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 13px;\n  border-radius: 30px;\n}\n.chat_assistant_bot .content .chips__btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transition: 0.5s;\n  box-shadow: none !important;\n}\n.chat_assistant_bot .content .chips__btn:active {\n  box-shadow: none;\n  outline: none;\n}\n.chat_assistant_bot .br-15 {\n  border-radius: 15px;\n}\n.chat_assistant_bot .text-white-opacity {\n  color: #ffffffcc;\n}\n.chat_assistant_bot .animate-fade {\n  position: relative;\n  animation: fadeIn 0.8s;\n}\n.chat_assistant_bot .assistant_close_icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n  font-size: 12px;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.chat_assistant_bot .assistant_close_icon em {\n  transform: rotate(-360deg);\n  transition: transform 1s ease;\n  display: block;\n  color: #0000005c;\n  cursor: pointer;\n  font-size: 12px !important;\n}\n.chat_assistant_bot .assistant_close_icon em:hover {\n  transform: rotate(360deg);\n  transition: transform 1s ease;\n}\n.chat_assistant_bot .animated_icon {\n  animation: rotate 550ms ease;\n}\n.chat_assistant_bot .py-c-3 {\n  padding: 1.2rem 0;\n}\n@keyframes fadeIn {\n  0% {\n    right: -300px;\n    opacity: 0;\n  }\n  100% {\n    right: 0;\n    opacity: 1;\n  }\n}\n@keyframes rotate {\n  0% {\n    transform: rotate(-360deg);\n    transition: transform 550ms ease;\n  }\n  100% {\n    transform: rotate(360deg);\n    transition: transform 550ms ease;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
